module.exports = __webpack_public_path__ + "img/Saques.a31a0d11.png";